var path = '@collectivehealth/get-care/components/buttons/backButton/backButton.html';
var html = "<gc-text-button click=\"BackButton.click()\">\n  <span class=\"BackButton\">\n    <dls-icon-arrow-left class=\"BackButton__icon\"></dls-icon-arrow-left>\n    <span ng-transclude>Back</span>\n  </span>\n</gc-text-button>\n";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;